import React, { useState } from 'react';
import { Record } from 'immutable';
import pick from 'lodash/pick';

// Hooks
import { useDeepEqualSelector } from 'Shared/utils/hooks';

// Utils
import { getSortedItems } from 'Shared/utils/sorting';
import { getIsDateAfter } from 'Shared/utils/DateTime.utils';

// Types
import { WorkspaceMeetingMode } from 'Shared/types/WorkspaceMeetingMode.type';

// Helpers
import WorkspaceMeetingModeHelper from 'Shared/model_helpers/WorkspaceMeetingMode.helper';

// Selectors
import { getItemsForStandardView } from 'Shared/selectors/workspace';

// Components
import { WpContainer, WpContainerHeader, WpContainerBody } from 'Wpds/components/container';
import ActionItemsTable from 'Shared/components/ActionItems/ActionItemsTable/ActionItemsTable';

// Styles
import './OtherActionItems.scss';

const ActionItemWhiteList = Object.freeze([
  'id',
  'uuid',
  'parentUuid',
  'workspacePath',
  'parentText',
  'isHighPriority',
  'workspaceId',
  'assignmentAvatar',
  'position',
]);

const sortingMap = {
  actionItems: 'default',
  owner: 'default',
  workspace: 'default',
  dueDate: 'default',
};

type Props = {
  meetingModeSession: Record<WorkspaceMeetingMode>;
};

const OtherActionItems = ({ meetingModeSession }: Props) => {
  const [selectedSort, setSelectedSort] = useState(sortingMap);

  const sessionCreatedAt = WorkspaceMeetingModeHelper.getCreatedAt(meetingModeSession);

  const actionItems = useDeepEqualSelector(state => [
    ...getSortedItems({
      items: getItemsForStandardView(state.workspace.meeting_items),
      selectedSort,
      withHighPriority: true,
      positionField: 'position',
    })
      .filter(actionItem => getIsDateAfter(sessionCreatedAt, actionItem.createdAt) === false)
      .map(actionItem => pick(actionItem, ActionItemWhiteList)),
  ]);

  const hasActionItems = actionItems.length > 0;

  const baseClassName = 'OtherActionItems';
  return (
    <WpContainer className={baseClassName}>
      <WpContainerHeader>Other Action Items in This Workspace</WpContainerHeader>
      <WpContainerBody>
        {hasActionItems && (
          <ActionItemsTable
            forbidDrag
            actionItems={actionItems}
            selectedSort={selectedSort}
            setSelectedSort={setSelectedSort}
            withOwnerSection
            withWorkspaceSection={false}
            enableHideAnimation={false}
          />
        )}
      </WpContainerBody>
    </WpContainer>
  );
};

export default OtherActionItems;
